import { AsyncPipe, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { catchError, Observable, of } from 'rxjs';

import { PatientService } from '@Services';
import { Demographic } from '@Models';

import { ErrorSummaryComponent } from '../../error-summary/error-summary.component';
import { LoadingSpinnerComponent } from '../../loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-school',
  imports: [AsyncPipe, ErrorSummaryComponent, LoadingSpinnerComponent, DatePipe],
  templateUrl: './school.component.html',
  styleUrl: './school.component.css',
})
export class SchoolComponent implements OnInit {
  nhsNumber: string | null = null;
  demographic$: Observable<Demographic | null> | null = null;
  errorMessage: string | null = null;
  errorStatus: string | null = null;

  constructor(
    private _patientService: PatientService,
    private router: Router,
  ) {}

  ngOnInit() {
    const urlSegments = this.router.url.split('/');
    if (urlSegments.length > 2) {
      this.nhsNumber = urlSegments[urlSegments.length - 2];
      this.loadDemographicData();
    }
  }

  private loadDemographicData() {
    if (this.nhsNumber) {
      this.demographic$ = this._patientService.demographic(this.nhsNumber).pipe(
        catchError((error) => {
          if (error.status === 404) {
            this.errorMessage = 'The child has no information recorded in this section.';
            this.errorStatus = '404';
          } else {
            this.errorMessage = 'An error occurred while fetching demographic data.';
          }
          return of(null);
        }),
      );
    }
  }
}
